import React from "react";
import "./Tags.css";

export default function Tags({ contact }) {
  const tag = (() => {
    switch (true) {
      case !contact?.interacted_at:
        return <div className="tag -red">Não interagido!</div>;
      default:
        return null;
    }
  })();

  return <div className="Tags">{tag}</div>;
}
